import { useState, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Typography, Stack } from '@mui/material';

import { FloatingPanel } from '@/modules/common/components/FloatingPanel';

export const useConfirm = () => {
  const [promise, setPromise] = useState(null);
  const [title, setTitle] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const { t } = useTranslation('common');

  const confirm = ({ title, message }: { title?: string; message?: string }) =>
    new Promise<boolean>((resolve) => {
      if (title) setTitle(title);
      if (message) setMessage(message);

      // @ts-expect-error strictNullChecks. Pls fix me
      setPromise({ resolve });
    });

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = (event: MouseEvent<HTMLElement>, stopPropagation?: boolean) => {
    // @ts-expect-error strictNullChecks. Pls fix me
    promise?.resolve(true);
    handleClose();

    if (stopPropagation) {
      event.stopPropagation();
    }
  };

  const handleCancel = (event?: MouseEvent<HTMLElement>, stopPropagation?: boolean) => {
    // @ts-expect-error strictNullChecks. Pls fix me
    promise?.resolve(false);
    handleClose();

    if (stopPropagation && event) {
      event.stopPropagation();
    }
  };

  type Props = {
    negativeBtnTextCustom?: string;
    stopPropagation?: boolean;
  };

  function Dialog({ negativeBtnTextCustom, stopPropagation }: Props) {
    return (
      <FloatingPanel onClose={handleCancel} open={promise !== null}>
        <Stack gap={1}>
          <Typography variant='h4'>{title}</Typography>
          <Stack spacing='10px'>
            <Stack
              gap={1}
              sx={{
                maxHeight: '200px',
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
            >
              <Typography>{message}</Typography>
              <Stack
                direction='row'
                gap={0.5}
                sx={{
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  paddingTop: '15px',
                }}
              >
                <Button onClick={(event) => handleConfirm(event, stopPropagation)}>{t('common:yes')}</Button>
                <Divider />
                <Button onClick={(event) => handleCancel(event, stopPropagation)} variant='secondary'>
                  {negativeBtnTextCustom || t('common:cancel')}
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </FloatingPanel>
    );
  }

  return { confirm, Dialog };
};
